import type { HealthIndicator as HI } from "../lib/types";

interface Props {
  id: string;
  indicator: HI;
}

function tierFor(score: number): string {
  if (score >= 0.85) return "good";
  if (score >= 0.5) return "warn";
  return "poor";
}

const TONE_COLOR: Record<string, string> = {
  good: "text-kw-l2",
  warn: "text-kw-l4",
  poor: "text-red-400",
};

export default function HealthIndicatorRow({ id, indicator }: Props) {
  const tier = tierFor(indicator.score);
  const tone = TONE_COLOR[tier] ?? "text-kw-text-muted";
  return (
    <div className="flex items-center justify-between text-xs py-1 border-b border-kw-border-subtle last:border-b-0">
      <div className="text-kw-text-primary font-mono">
        {id}{" "}
        <span className="text-kw-text-faint">
          (weight {indicator.weight.toFixed(2)})
        </span>
      </div>
      <div className={`font-mono ${tone}`}>
        score {indicator.score.toFixed(2)}{" "}
        <span className="text-kw-text-faint">
          {indicator.raw_value !== null
            ? `· raw ${indicator.raw_value.toFixed(2)}`
            : "· raw —"}
        </span>
      </div>
    </div>
  );
}
